export class SecondhandGateway {
  mac?: string;
  startDate?: string;
  endDate?: string;

  constructor(params?: Partial<SecondhandGateway>) {
    Object.assign(this, params);
  }
}